import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(28)}
    height={scaleSize(48)}
    viewBox="0 0 28 48"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#ffffff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
      d="M24 4L4 24l20 20"
    />
  </svg>
);
